var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantEmptyAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.379 56.578c11.329-.752 20.353-9.905 21.095-21.394a53.53 53.53 0 000-6.826c-.742-11.49-9.766-20.642-21.095-21.395a89.868 89.868 0 00-11.758 0C15.292 7.716 6.268 16.87 5.526 28.358a53.493 53.493 0 000 6.826c.27 4.184 2.12 8.059 4.3 11.33 1.265 2.291.43 5.15-.888 7.647-.95 1.8-1.425 2.7-1.044 3.35.382.651 1.234.672 2.938.713 3.37.082 5.642-.873 7.446-2.203 1.023-.754 1.534-1.132 1.887-1.175.352-.043 1.046.242 2.433.814 1.247.513 2.695.83 4.023.919 3.858.256 7.893.257 11.758 0z",
    fill: "url(#ai-assistant-empty-avatar_svg__paint0_linear_653_3296)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-assistant-empty-avatar_svg__paint0_linear_653_3296",
    x1: 32.5,
    y1: 6.771,
    x2: 32.5,
    y2: 58.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
export default SvgAiAssistantEmptyAvatar;